export function shouldBypassDnd(type: string, data: Record<string, unknown> = {}): boolean {
  const normalizedType = (type || '').toLowerCase();
  const isCallLike = normalizedType === 'call'
    || normalizedType === 'missedcall'
    || normalizedType === 'call-canceled'
    || normalizedType === 'call-invite';

  const isIncomingCallInvite = normalizedType === 'call'
    && !!data?.callSessionId
    && (data?.callType === 'calls' || data?.callType === 'invite' || !data?.callType)
    && !data?.status
    && !data?.event
    && data?.isCall !== false
    && !data?.isCallAccepted
    && !data?.isCallJoined;

  const isCallControlEvent = isCallLike && (
    !!data?.status
    || !!data?.event
    || !!data?.isCallAccepted
    || !!data?.isCallJoined
    || normalizedType === 'call-canceled'
    || normalizedType === 'call-invite'
  );

  // Threats must always break through DND. Manual threats arrive as type 'threat';
  // automatic detections arrive as 'weapon-detected' (and future variants may embed
  // 'threat'), so match all of them rather than the single 'threat' literal (#1047 A12).
  const isThreat = normalizedType === 'threat'
    || normalizedType === 'weapon-detected'
    || normalizedType.includes('threat');
  if (isThreat) {
    return true;
  }

  return isIncomingCallInvite || normalizedType === 'missedcall' || isCallControlEvent;
}
